"use client";

import { c as _c } from "react/compiler-runtime";
import { useDropCurations } from "./useDropCurations";
export function useCanShowDropCurationsAction(t0) {
  const $ = _c(7);
  const {
    dropId,
    isTemporaryDrop,
    isWaveAdmin,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const shouldCheckCurations = enabled && !isTemporaryDrop && !isWaveAdmin;
  let t2;
  if ($[0] !== dropId || $[1] !== shouldCheckCurations) {
    t2 = {
      dropId,
      enabled: shouldCheckCurations
    };
    $[0] = dropId;
    $[1] = shouldCheckCurations;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: t3
  } = useDropCurations(t2);
  let t4;
  if ($[3] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const curations = t4;
  let t5;
  if ($[5] !== curations) {
    t5 = curations.some(_temp);
    $[5] = curations;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const hasManageableCurations = t5;
  return !isTemporaryDrop && (isWaveAdmin || hasManageableCurations);
}
function _temp(curation) {
  return curation.authenticated_user_can_curate === true;
}